<template>
  <div class="menu-config-management">
    <el-card>
      <div slot="header">
        <span>导航菜单配置</span>
        <el-button style="float: right; padding: 3px 10px" type="primary" size="small" @click="showAddDialog">
          添加菜单项
        </el-button>
      </div>
      
      <el-table :data="menuItems" style="width: 100%" v-loading="loading">
        <el-table-column label="排序" width="80">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" icon="el-icon-top" @click="moveUp(scope.$index)" :disabled="scope.$index === 0"></el-button>
              <el-button size="mini" icon="el-icon-bottom" @click="moveDown(scope.$index)" :disabled="scope.$index === menuItems.length - 1"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="菜单名称" width="150"></el-table-column>
        <el-table-column label="链接类型" width="100">
          <template slot-scope="scope">
            {{ scope.row.isExternal ? '外部链接' : '内部路由' }}
          </template>
        </el-table-column>
        <el-table-column prop="url" label="链接地址"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled ? 'success' : 'info'">
              {{ scope.row.enabled ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="editMenuItem(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteMenuItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    
    <!-- 添加/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="currentItem" :rules="rules" ref="itemForm" label-width="100px">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="currentItem.name" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        
        <el-form-item label="链接类型" prop="isExternal">
          <el-radio-group v-model="currentItem.isExternal">
            <el-radio :label="false">内部路由</el-radio>
            <el-radio :label="true">外部链接</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="链接地址" prop="url">
          <el-input 
            v-model="currentItem.url" 
            :placeholder="currentItem.isExternal ? '请输入完整URL（如：https://example.com）' : '请输入路由路径（如：/services）'">
          </el-input>
        </el-form-item>
        
        <el-form-item label="启用状态">
          <el-switch v-model="currentItem.enabled"></el-switch>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveMenuItem">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MenuConfigManagement',
  data() {
    return {
      menuItems: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '添加菜单项',
      currentItem: {
        id: null,
        name: '',
        url: '',
        isExternal: false,
        enabled: true,
        sortOrder: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入链接地址', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadMenuItems()
  },
  methods: {
    async loadMenuItems() {
      this.loading = true
      try {
        const response = await this.$http.get('/config/menu/all')
        if (response.success && response.data) {
          this.menuItems = response.data || []
        }
      } catch (error) {
        this.$message.error('加载菜单失败')
        console.error('加载菜单失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    showAddDialog() {
      this.dialogTitle = '添加菜单项'
      this.currentItem = {
        id: null,
        name: '',
        url: '',
        isExternal: false,
        enabled: true,
        sortOrder: this.menuItems.length
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.itemForm && this.$refs.itemForm.clearValidate()
      })
    },
    
    editMenuItem(item) {
      this.dialogTitle = '编辑菜单项'
      this.currentItem = { ...item }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.itemForm && this.$refs.itemForm.clearValidate()
      })
    },
    
    saveMenuItem() {
      this.$refs.itemForm.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.currentItem.id) {
              // 更新
              response = await this.$http.put(`/config/menu/${this.currentItem.id}`, this.currentItem)
            } else {
              // 添加
              response = await this.$http.post('/config/menu', this.currentItem)
            }
            
            if (response.success) {
              this.$message.success(this.currentItem.id ? '菜单项更新成功' : '菜单项添加成功')
              this.dialogVisible = false
              this.loadMenuItems()
            } else {
              this.$message.error('操作失败: ' + response.message)
            }
          } catch (error) {
            this.$message.error('操作失败')
            console.error('操作失败:', error)
          }
        }
      })
    },
    
    deleteMenuItem(item) {
      this.$confirm(`确定要删除菜单项"${item.name}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await this.$http.delete(`/config/menu/${item.id}`)
          if (response.success) {
            this.$message.success('删除成功')
            this.loadMenuItems()
          } else {
            this.$message.error('删除失败: ' + response.message)
          }
        } catch (error) {
          this.$message.error('删除失败')
          console.error('删除失败:', error)
        }
      }).catch(() => {})
    },
    
    async moveUp(index) {
      if (index === 0) return
      const temp = this.menuItems[index]
      this.menuItems[index] = this.menuItems[index - 1]
      this.menuItems[index - 1] = temp
      await this.updateOrder()
    },
    
    async moveDown(index) {
      if (index === this.menuItems.length - 1) return
      const temp = this.menuItems[index]
      this.menuItems[index] = this.menuItems[index + 1]
      this.menuItems[index + 1] = temp
      await this.updateOrder()
    },
    
    async updateOrder() {
      // 更新sortOrder
      this.menuItems.forEach((item, index) => {
        item.sortOrder = index
      })
      
      try {
        const response = await this.$http.put('/config/menu/order', this.menuItems)
        if (response.success) {
          this.$message.success('顺序更新成功')
        }
      } catch (error) {
        this.$message.error('顺序更新失败')
        console.error('顺序更新失败:', error)
        this.loadMenuItems()
      }
    }
  }
}
</script>

<style scoped>
.menu-config-management {
  max-width: 1000px;
}
</style>
